module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g stroke=\"#FFF\" stroke-width=\"3\" fill=\"none\" fill-rule=\"evenodd\">\n    <circle cx=\"16\" cy=\"16\" r=\"14.5\"/>\n    <path d=\"M6.0067674 26.4598993L27.4059252 5.06074147\"/>\n  </g>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./public/img/cancel.svg
// module id = Qqn5
// module chunks = 5